import React, { useState, useEffect, useContext } from 'react';
import ExamBody from './ExamBody'
import ExamQuest from './ExamQuest'
import WebServiceContext from '../WebService/ServiceContext'
import { BasicContext } from '../context/BasicContext'
import { ExamContext } from '../context/ExamContext'

import { HibModal } from "../course/HibModal";

//import { useSelector, shallowEqual } from "react-redux"

import ExamInfo from './ExamInfo';
import { Spinner, Yes } from '../course/SVG';



/** 
 * 主要入口
 * 處理從server來的資料並派送到各個components
 * 狀態顯示
 */
const ExamApp = () => {

    //const [isTesting, setIsTesting] = useState<boolean>(false);
    const [isAnswered, setIsAnswered] = useState<boolean>(false);
    const ws = useContext(WebServiceContext)
    const ec = useContext(ExamContext)
    const bc = useContext(BasicContext)

    //控制只有正常讀取資料時可以顯示問卷選單
    const [loadState, setLoadState] = useState<boolean>(false)

    //有尚未作答完成的資料
    const [tempData, setTempData] = useState<string | null>(null)
    const [tempOpen, setTempOpen] = useState<boolean>(false)
    const [answerNum, setAnswerNum] = useState<number>(0)
   
    //mount 取得資料
    useEffect(() => {
        let ExamID: number = parseInt(bc.ExamPaper)
        let currentExamInfo: ExamInfo = {} as ExamInfo
        let ExamData: ExamUnit[] = []
        ws.ExamService.getExamInfo(ExamID.toString()).then((result) => {
            
            if (result) {
                setLoadState(true)
                const res = result as ResultData;
                const ei: ExamInfo = res.Data[0] as ExamInfo

                currentExamInfo = {
                    ExamID: ExamID,
                    title: ei.ExamName,
                    Memo: ei.Memo,
                    AnsKind: ei.AnsKind,
                    TestMinute: ei.TestMinute,
                    Optional: ei.Optional,//1:自選|0:非自選 這邊如果是自選 需要加上自選題數(尚未製作)
                    QRecCount: ei.QRecCount, //預設題數 
                } as ExamInfo

                return ws.ExamService.getExamComplete(bc.ActID, ei.ExamID.toString())
            }
        }).then(result => {
            const res = result as ResultData;
            const ei: ExamInfo = res.Data[0] as ExamInfo
            if (ei && ei.LastUpdate) {
                currentExamInfo = {
                    ...currentExamInfo,
                    LastUpdate: ei.LastUpdate,
                } as ExamInfo
            }
            return ws.ExamService.getExamList(ExamID.toString(), currentExamInfo.Optional.toString(), currentExamInfo.QRecCount.toString());
        }).then(result => {
            const res = result as ResultData;
            const ary: Array<ExamUnit> = [];

            res.Data.map((item, index) => {
                const _it = item as ExamInfo;
                let ex: ExamUnit = {
                    id: index,
                    QSNo: _it.QSNo,
                    question: _it.QName,
                    answersList: _it.Answers ? JSON.parse(_it.Answers.toString()) as Array<ExamAnswer> : [],
                    userAnswer: null
                };
                ary.push(ex)
            })
            //console.log(res.Data[0].ExamType)
            currentExamInfo = {
                ...currentExamInfo,
                ExamType: res.Data[0].ExamType
            }
            ExamData = ary
            ec.setExamData(ary)
            ec.setExamInfo(currentExamInfo)


            //console.log(currentExamInfo)
            
            return ws.WebService.asyncGetAnswer(bc.ActID, ExamID)
        }).then(res => {
            //202408016新增 滿意度調查取得使用者的答案
            //已有回答的題目 且與題目列表的數字相同
            console.log(res)
            if (
                (res as []).length > 0 &&
                (res as []).length == ExamData.length
            ) {
                setIsAnswered(true)
            }

            //20241106取得暫存檔
            const tdo: TempDataObject = {
                Action: "GET",
                ActID: bc.ActID,
                ExamID: ExamID
            }
            return ws.ExamService.tempDataAction(tdo)
        }).then((res: any) => {
            //console.log(JSON.parse(res.Data[0].TempData))
            /*
            20241107先暫時關閉
            if (res.Data[0].TempData) {
                setTempData(res.Data[0].TempData)
            }
            */
        })

        return
    }, [])
    /*
        useEffect(()=>{
            console.log(ec.examInfo)
        },[ec])
    */
    if (ec.examInfo.ExamType == "1" || ec.examInfo.ExamType == "3") {
        return (
            <div className="hib-exam">

                {
                    ec.isTesting ?
                        <ExamBody
                            answerResult={true}//答題類型:true=>逐步回答型, false=>計算總分型
                            answerNum={answerNum}
                        />
                        :
                        <>
                            <ExamInfo showType='exam' />
                            {
                                //<button className='hibBtn main'>回課程列表</button>
                            }
                            {
                                isAnswered && ec.examInfo.ExamType == "3" ?
                                    <div className='already'>
                                        <Yes />
                                        您已經作答完畢！
                                    </div>
                                    :
                                    <button className='hibBtn main full large start' onClick={() => {
                                        if (tempData) {
                                            setTempOpen(true)
                                        } else {

                                            ec.setIsTesting(true)
                                        }

                                    }}>開始作答</button>
                            }
                        </>
                }
                <HibModal
                    type="notice"
                    show={tempOpen}
                    showCross={false}
                    confirm={() => {
                        if(tempData){
                            const _td = JSON.parse(tempData)
                            ec.setExamData(_td.examData)
                            ec.setRecord(_td.record)
                            setAnswerNum(_td.record.length)
                            
                        }
                        setTempOpen(false)
                        ec.setIsTesting(true)
                    }}
                    cancel={() => {
                        setTempOpen(false)
                        ec.setIsTesting(true)
                    }}
                >
                    您有尚未作答完成的紀錄，您要從上次的進度開始嗎？
                </HibModal>
            </div>
        )
    } else {

        return (
            <div className="hib-exam">
                {
                    loadState ?
                        <>
                            <ExamInfo showType='ques' />
                            <ExamQuest examID={parseInt(bc.ExamPaper)} />
                        </> :
                        <>
                            <Spinner />
                        </>
                }
            </div>
        )
    }
}

export default ExamApp;
